export const environment = {
  production: true,
  version: '2.5.5.13',
  sentry: {
    enable: true,
    dsn: 'https://ec064947f37e40e2a17ad85cbe79aa46@o391708.ingest.sentry.io/5238290',
  },
};
